import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import noneImage from '../assets/none-png-2.png'

const Container = styled.div`
    font-size:12px;
    min-height:350px;
    @media screen and (max-width:768px) {
        min-height:220px;
    }
`

const Image = styled.div`
    width:200px;
    height:300px;
    margin-right:20px;
    background-size: cover;
    background-position: center center;
    border-radius: 4px;
    transition: 0.1s linear;
    background-image:url(${props => props.bgUrl});
    @media screen and (max-width:768px){
        width:100px;
        height:170px;
        margin-right:10px;
        border-radius:2px;
    }
`

const Rating = styled.span`
    font-size:15px;
    position: absolute;
    bottom: 5px;
    right: 25px;
    opacity: 0;
    transition: 0.1s linear;
    `

const ImageContainer = styled.div`
margin-bottom: 5px;
position: relative;
    &:hover{
    ${ Image} {
        opacity: 0.3;
    }
    ${ Rating} {
        opacity: 1;
    }
}
`

const Title = styled.span`
    font-size:18px;
    display: block;
    margin-bottom: 3px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
    @media screen and (max-width:768px) {
        font-size:15px;
        width:100px;
    }
    `

const Year = styled.span`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.5);
    `

const Poster = ({ id, imgUrl, title, rating, year, isMovie = false }) =>

    <Link to={isMovie ? `/movie/${id}/` : `/show/${id}/`}>
        <Container>
            <ImageContainer>
                <Image bgUrl={imgUrl ? `https://image.tmdb.org/t/p/w500${imgUrl}` : noneImage} />

                <Rating>
                    <span role='img' aria-label='rating' >
                        ⭐
                    </span>{" "}
                    {rating}/10
                </Rating>
            </ImageContainer>
            <Title>{title.length > 21 ? title.substring(0, 21) + '...' : title}</Title>
            <Year>{year}</Year>
        </Container>
    </Link>

Poster.propTypes = {
    id: PropTypes.number.isRequired,
    imgUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    rating: PropTypes.number,
    year: PropTypes.string,
    isMovie: PropTypes.bool
}

export default Poster